import { render, staticRenderFns } from "./feeManage.vue?vue&type=template&id=4652e5a2&scoped=true"
import script from "./feeManage.vue?vue&type=script&lang=js"
export * from "./feeManage.vue?vue&type=script&lang=js"
import style0 from "./feeManage.vue?vue&type=style&index=0&id=4652e5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652e5a2",
  null
  
)

export default component.exports